<template>
  <div class="welcome">
    <div class="unread_container"> 
      <p class="user_name">Hi {{current_user_name}}!</p>
      <div v-if="unreadCount > 0" class="unread">
        <span>You have {{unreadCount}} unread </span>
        <span v-if="unreadCount == 1">message</span>
        <span v-else>messages</span>
      </div>
    </div>          
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {},
  props: ['current_user_name', 'unreadCount'],
  data: () => ({

  }),
}
</script>

<style lang="scss" scoped> 
.welcome{
  height: 100%;
  width: 100%;
  .unread_container {
    height: 100%;
    width: 100%;
    position: relative;
    .unread {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    }
    .user_name {
    font-size: 24px;
    font-weight: 700;
    color: #000000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    }
  }
}
</style>